import React, { useEffect } from "react"
import { useQuizContext } from "./QuizContext"
import Button from "@/components/core/Button/Button"
import { sections, resetQuiz, generateImageUrl } from "./helper"

const QuizIntro = () => {
  const {
    setSection = () => {},
    data = {},
    setData,
    setCurQuestion,
    config = {},
  } = useQuizContext()

  useEffect(() => {
    resetQuiz(setData, setCurQuestion)
  }, [])

  return (
    <div className="quiz-intro">
      <section className="banner">
        <img
          src={generateImageUrl(data?.landingImage, config, 700, 700)}
          alt=""
        />
      </section>
      <section className="text">
        <div>
          <h1>{data?.landingTitle}</h1>
          <p>{data?.landingDescription}</p>
          <Button
            type="ghost"
            role="button"
            label={data?.landingButtonTxt}
            onClick={() => setSection(sections.QUIZ)}
            size="small"
          />
        </div>
      </section>
    </div>
  )
}

export default QuizIntro
